var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTollRoad01 = function SvgTollRoad01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "toll-road-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#toll-road-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12a11.99 11.99 0 0 1-5.984 10.384l-.022.013A11.922 11.922 0 0 1 12 24a11.893 11.893 0 0 1-5.972-1.591l-.021-.012A11.994 11.994 0 0 1 0 11.999C0 7.556 2.415 3.675 6.005 1.603l.021-.012A11.934 11.934 0 0 1 12 0a11.964 11.964 0 0 1 6.017 1.616A11.992 11.992 0 0 1 24 12h-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.999 5.966V10.558h-12V5.966a8.482 8.482 0 0 1 6-2.475c2.341 0 4.462.945 6 2.475Zm-5.7.76V4.759h-.6v1.968h.6Zm0 3.13V7.886h-.6v1.968h.6ZM6 18.033v-4.628h12v4.628a8.482 8.482 0 0 1-6 2.475 8.482 8.482 0 0 1-6-2.475Zm6.3 1.207h-.6v-1.968h.6v1.968Zm-.6-3.13v.002h.6V14.144h-.6v1.968Zm-8.135-4.954v1.649h.714v2.95h1.099v-2.95h13.245v2.95h1.098v-2.95h.715v-1.649H3.564Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "toll-road-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgTollRoad01 as ReactComponent };